import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Post, PostsResponse, PostsState } from "../../types/types";

export const getPosts = createAsyncThunk<Post[], void, { rejectValue: string }>(
  "posts/getPosts",
  async (_, { rejectWithValue }) => {
    try {
      const API_URL = process.env.REACT_APP_URL_BACKEND;
      const response = await fetch(`${API_URL}/api/v1/posts/`);

      if (!response.ok) {
        return rejectWithValue("Ошибка при загрузке постов");
      }

      const data: PostsResponse = await response.json();

      return data.results;
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }

      return rejectWithValue("Неизвестная ошибка");
    }
  }
);

const initialState: PostsState = {
  posts: [],
  loading: false,
  error: null,
};

const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPosts.fulfilled, (state, action) => {
        state.loading = false;
        state.posts = action.payload;
      })
      .addCase(getPosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? "Произошла ошибка";
      });
  },
});

export default postsSlice.reducer;
